import { RateCodeSearchState } from '~/components/Cruises/components/shared/RateCodeGridConfig';

export const rateCodeQueryKeys = {
  all: ['rate-codes'] as const,
  lists: () => [...rateCodeQueryKeys.all, 'list'] as const,
  list: (vendorCode: string | undefined, search: RateCodeSearchState, page: number) =>
    [...rateCodeQueryKeys.lists(), vendorCode, search, page] as const,
};
